function muskleAvatarFallback(img) {
  if (!img || img.dataset.fellback === "1") return;
  img.dataset.fellback = "1";
  if (img.classList.contains("share-photo")) img.classList.add("share-photo-placeholder");
  const frame = img.closest(".avatar");
  if (frame) frame.classList.add("avatar-placeholder");
  const next = img.getAttribute("data-fallback");
  if (next && img.getAttribute("src") !== next) img.src = next;
}

document.querySelectorAll("img[data-fallback]").forEach((img) => {
  img.addEventListener("error", () => muskleAvatarFallback(img));
  if (img.complete && img.naturalWidth === 0) muskleAvatarFallback(img);
});
